import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import logo from '../../assets/logo/FPHC_Logo_RGB_150118_klein_Deckblatt.png';
import akkreditierung from '../../assets/certifications/0403_17020_FPHC-Akkreditierungszeichen.jpg';
import ingbuero from '../../assets/certifications/ingenieurbuero.png';
import akkreditierungsbestatigung from '../../assets/pdf/403_Akkreditierungsbestatigung_I_2023.pdf';
import akkreditierungsumfang from '../../assets/pdf/2023-0803.603_Akkreditierungsumfang_Bescheid.pdf';
import agbs from '../../assets/pdf/FP_ANF_ID_AGBs_V3_DE_2020_gesichert.pdf'

const Footer = () => {
  const handleAddressClick = () => {
    const address = 'Tischlerbauerstraße 11, 4060 Leonding/Rufling';
    const encodedAddress = encodeURIComponent(address);
    
    // Check if the device is iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    // Generate the appropriate maps URL
    const mapsUrl = isIOS
      ? `maps://maps.apple.com/?q=${encodedAddress}`
      : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    
    window.open(mapsUrl, '_blank');
  };

  return (
    <footer className="bg-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Logo and Company Info */}
          <div className="md:col-span-4">
            <img 
              src={logo}
              alt="FPHC Logo" 
              className="h-10 sm:h-12 w-auto mb-6"
            />
            <p className="text-gray-900 font-medium mb-2 text-sm sm:text-base">
              Ingenieurbüro (Beratende Unternehmen)<br />
              für das Fachgebiet Technischer Umweltschutz
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Ihr zuverlässiger Partner für Umwelttechnik und Beratung
            </p>
          </div>

          {/* Contact & Location */}
          <div className="md:col-span-4">
            <h3 className="text-sm font-medium text-gray-900 mb-4">Kontakt & Standorte</h3>
            <div className="space-y-3">
              <a href="tel:+436644704858" className="flex items-center space-x-2 text-gray-600 hover:text-success transition-colors">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span className="text-sm">+43 664 470 48 58</span>
              </a>
              <div className="space-y-2 text-gray-600">
                <div className="flex items-center space-x-2">
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  <a href="mailto:office@fphc.at" className="text-sm hover:text-success transition-colors">office@fphc.at</a>
                </div>
                <div className="pl-6 space-y-1">
                  <a href="mailto:rechnung@fphc.at" className="block text-sm text-gray-500 hover:text-success transition-colors">
                    Rechnungen: rechnung@fphc.at
                  </a>
                  <a href="mailto:team@fphc.at" className="block text-sm text-gray-500 hover:text-success transition-colors">
                    Projektanfrage: team@fphc.at
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-2 text-gray-600">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <button 
                  onClick={handleAddressClick}
                  className="text-left text-sm hover:text-success transition-colors"
                >
                  <p>Tischlerbauerstraße 11,</p>
                  <p>4060 Leonding/Rufling</p>
                </button>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div className="md:col-span-2">
            <div className="flex md:flex-col sm:grid sm:grid-cols-2 md:grid-cols-none gap-4">
              <div className="group relative bg-white rounded-lg p-2 shadow-sm hover:shadow-md transition-shadow duration-300 w-32 md:w-40">
                <img 
                  src={akkreditierung}
                  alt="FPHC Akkreditierungszeichen" 
                  className="w-16 h-16 md:w-20 md:h-20 object-contain transform group-hover:scale-105 transition-transform duration-300 mx-auto"
                />
                <div className="absolute inset-0 rounded-lg ring-1 ring-gray-200 group-hover:ring-success/30 transition-colors duration-300" />
              </div>
              <div className="group relative bg-white rounded-lg p-2 shadow-sm hover:shadow-md transition-shadow duration-300 flex items-center justify-center w-32 md:w-40">
                <img 
                  src={ingbuero}
                  alt="Ingenieurbüro Zertifizierung" 
                  className="w-16 h-16 md:w-20 md:h-20 object-contain transform group-hover:scale-105 transition-transform duration-300 mx-auto"
                />
                <div className="absolute inset-0 rounded-lg ring-1 ring-gray-200 group-hover:ring-success/30 transition-colors duration-300" />
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h3 className="text-sm font-medium text-gray-900 mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-success transition-colors">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-success transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-success transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-success transition-colors">
                  Angebot anfordern
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500 text-center md:text-left">
              © {new Date().getFullYear()} FPHC UmweltConsulting GmbH. Alle Rechte vorbehalten.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    agbs,
                    'AGBs',
                    'width=900,height=1200,scrollbars=yes'
                  );
                }}
                className="text-sm text-gray-500 hover:text-success transition-colors"
              >
                AGBs
              </a>
              <Link to="/impressum" className="text-sm text-gray-500 hover:text-success transition-colors">Impressum</Link>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    akkreditierungsbestatigung,
                    'Akkreditierungsbestätigung',
                    'width=900,height=1200,scrollbars=yes'
                  );
                }}
                className="text-sm text-gray-500 hover:text-success transition-colors"
              >
                Akkreditierungsbestätigung
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    akkreditierungsumfang,
                    'Akkreditierungsumfang',
                    'width=900,height=1200,scrollbars=yes'
                  );
                }}
                className="text-sm text-gray-500 hover:text-success transition-colors"
              >
                Akkreditierungsumfang
              </a>
              <Link to="/datenschutz" className="text-sm text-gray-500 hover:text-success transition-colors">Datenschutz</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;